import { generatePath } from 'react-router';
import { ROUTES } from 'routes/types';

export const getVehicleDetailsPath = (vin?: string) =>
    vin
        ? generatePath(`/${ROUTES.VEHICLE_BY_VIN}`, {
              vin,
          })
        : `/${ROUTES.VEHICLE}`;
// Live handle to the vehicle-details window we opened in this session. Lets us close it
// directly without re-invoking window.open('', name), which would otherwise spawn (and then
// immediately close) a blank popup when no window with that name exists anymore.
let vehicleDetailsWindow: Window | null = null;

export const isVehicleDetailsWindowOpen = () => vehicleDetailsWindow !== null && !vehicleDetailsWindow.closed;

export const navigateToVehicleDetails = (vin?: string) => {
    if (!isVehicleDetailsWindowOpen()) {
        const tabId = 'vehicle-details';
        const path = getVehicleDetailsPath(vin);
        vehicleDetailsWindow = window.open(path, tabId, `name=${tabId}`);
        return tabId;
    }

    // The window already exists. A selection brings it to the front; a deselection must leave it
    // where it is, so we only focus when a vehicle is actually selected.
    if (vin !== undefined) {
        vehicleDetailsWindow?.focus();
    }
};

export const closeVehicleDetailsWindow = (reference?: string) => {
    // Prefer the live handle from this session: closes cleanly with no blank-popup flash.
    if (vehicleDetailsWindow && !vehicleDetailsWindow.closed) {
        vehicleDetailsWindow.close();
        vehicleDetailsWindow = null;
        return;
    }

    // Fallback after a main-window reload, where the handle is gone but the reference
    // was restored from persisted state. Best-effort re-attach by name.
    if (reference) {
        window.open('', reference)?.close();
    }
};
